










































import CompanyUserRequired from "../CompanyRequired";
import {Component, Inject, Prop} from "vue-property-decorator";
import Api from "./Api";
import {TerminalGuiInfo, TerminalLocation} from "../../modules/models";
import Ellipsifier from "@/components/shared/Ellipsifier.vue";

@Component({
    components: {
        "at-ellipsifier": Ellipsifier
    }
})
export default class LocationTerminalSet extends CompanyUserRequired {
    @Inject()
    api!: Api;

    @Prop({default: false})
    value!: boolean;

    get opened() {
        return this.value;
    }
    set opened(v: boolean) {
        this.$emit("input", v);
    }

    @Prop()
    forLocation!: TerminalLocation;

    @Prop({default: () => []})
    terminalInfos!: TerminalGuiInfo[];

    get sortedTerminalInfos() {
        return this.terminalInfos.sort((a, b) => (a.location ? 100 : 1) - (b.location ? 101 : 2));
    }

    selected: TerminalGuiInfo | null = null;

    async select(ti: TerminalGuiInfo) {
        // If terminal has active location or is deactivated, ask user to confirm choice.
        if(ti.location != null || ti.terminal.deactivated != null) {
            this.selected = ti;
        } else {
            // set selected value directly
            await this.setTerminalLocationConfig(ti);
            this.opened = false;
        }
    }

    cancel() {
        this.selected = null;
        this.opened = false;
    }

    async confirm() {
        if(this.selected != null) {
            await this.setTerminalLocationConfig(this.selected);
        }
        this.opened = false;
        this.selected = null;
    }

    // Adds new terminal config to chosen terminal
    async setTerminalLocationConfig(ti: TerminalGuiInfo) {
        if(ti.terminal.deactivated != null) {
            await this.api.terminalActivate(ti.terminal.guid);
        }
        await this.api.terminalLocationSet(ti.terminal.guid, this.forLocation.id);
        this.emitSnack(`${ti.terminal.description} aktivert på anlegget. Synkroniser kortleser for å fullføre`, "info");
        this.$emit("at-location-terminal-set", ti.terminal);
    }

}
